export var CountriesLocaleEnum;
(function (CountriesLocaleEnum) {
    CountriesLocaleEnum["AUSTRIA"] = "at-AT";
    CountriesLocaleEnum["ENGLAND"] = "en-GB";
    CountriesLocaleEnum["GERMANY"] = "de-DE";
    CountriesLocaleEnum["NETHERLANDS"] = "nl-NL";
    CountriesLocaleEnum["SPAIN"] = "es-ES";
})(CountriesLocaleEnum || (CountriesLocaleEnum = {}));
//# sourceMappingURL=countries-locale.enum.js.map